import robuxModule from "../robuxModule";

function robuxPackage(premiumService, premiumConstants, $filter) {
    "ngInject";

    return {
        restrict: "A",
        scope: {
            userInfo: "=",
            product: "="
        },
        templateUrl: premiumConstants.templates.robuxPackage,
        link: function (scope) {
            scope.layout = {
                isPremiumUser: false,
                purchaseUrl: "#",
                isInApp: premiumService.inRobloxApp()
            };

            if (scope.product && scope.product.subscription) {
                scope.product.subscription.robuxAmount = $filter('localNumberFormat')(scope.product.subscription.robuxAmount);
            }

            scope.$watch(function () {
                return scope.userInfo;
            }, function () {
                if (scope.userInfo) {
                    scope.layout.isPremiumUser = scope.userInfo && scope.userInfo.hasOwnProperty('subscriptionTypeName');
                }
            });

            /* Purchase in desktop and mobile use different url request. Desktop is sending get request to UpgradesController; purchase in app is using a ajax request to /mobile-app-upgrades/buy url. */
            if (scope.layout.isInApp && scope.product) {
                scope.layout.purchaseUrl = premiumService.getPurchaseUrl(scope.product, premiumConstants.pageContext.robux);
            }
            scope.buyClick = function (product) {
                premiumService.sendInteractionClickEvent(premiumConstants.pageContext.robux,
                    premiumConstants.streamEventParams.buyBtn,
                    product.productId);
                if (!scope.layout.isInApp) {
                    var params = {
                        ap: product.productId,
                        page: premiumConstants.premiumFeatureType.robux
                    }
                    premiumService.purchaseSubscription(params);
                }
            }
        }
    };
}

robuxModule
    .directive("robuxPackage", robuxPackage);

export default robuxModule;